export enum UserRoles {
  ADMINISTRATOR = 'ADMINISTRATOR',
  ROCHE_ADMINISTRATOR = 'ROCHE_ADMINISTRATOR',
  LAB_TECHNICIAN = 'LAB_TECHNICIAN',
  GENETICIST = 'GENETICIST',
  LAB_DIRECTOR = 'LAB_DIRECTOR'
}
